import { memo } from "react";
import { Handle, type NodeProps } from "@xyflow/react";
import { Database } from "lucide-react";
import { cn } from "@/lib/utils";
import type { InputNodeData } from "@/types/decision-graph";
import { getHandlePositions } from "../utils/handle-positions";

export const InputNode = memo(function InputNode({
  data,
  selected,
}: NodeProps) {
  const d = data as InputNodeData;
  const { outputPosition } = getHandlePositions(d.layoutDirection);

  return (
    <div
      className={cn(
        "px-4 py-3 rounded-lg border-2 bg-white shadow-sm min-w-[140px]",
        "transition-all duration-150",
        selected
          ? "border-emerald-500 shadow-md ring-2 ring-emerald-200"
          : "border-emerald-300 hover:border-emerald-400"
      )}
    >
      <Handle
        type="source"
        position={outputPosition}
        id="result"
        style={{ background: "#10b981", width: 8, height: 8 }}
      />

      <div className="flex items-center gap-2 mb-2">
        <Database size={14} className="text-emerald-600" />
        <span className="text-xs font-semibold text-emerald-700">Input</span>
      </div>

      {d.inputSchemaRef && (
        <div className="text-[10px] text-muted-foreground mb-1 truncate max-w-[160px]">
          {d.inputSchemaRef}
        </div>
      )}

      {d.factPaths.length > 0 && (
        <div className="space-y-0.5">
          {d.factPaths.slice(0, 4).map((path) => (
            <div
              key={path}
              className="text-[10px] font-mono bg-emerald-50 px-1.5 py-0.5 rounded text-emerald-700 truncate max-w-[160px]"
            >
              {path}
            </div>
          ))}
          {d.factPaths.length > 4 && (
            <div className="text-[10px] text-muted-foreground">
              +{d.factPaths.length - 4} more
            </div>
          )}
        </div>
      )}
    </div>
  );
});
